import React, { useState } from 'react';
import {
  View, Text, TextInput, TouchableOpacity, StyleSheet,
  ScrollView, Alert,
} from 'react-native';
import { useAuth } from '../context/AuthContext';

const CIDADES_SUGERIDAS = [
  'Chapecó', 'Xanxerê', 'São Miguel do Oeste', 'Joaçaba',
  'Concórdia', 'Maravilha', 'Pinhalzinho', 'Palmitos',
];

const CATEGORIAS = [
  { value: '', label: 'Todos', icon: '🚗' },
  { value: 'carro', label: 'Carros', icon: '🚗' },
  { value: 'van', label: 'Vans', icon: '🚐' },
  { value: 'caminhao_b', label: 'Caminhões', icon: '🚚' },
];

export default function HomeScreen({ navigation }) {
  const { user } = useAuth();
  const [origem,    setOrigem]    = useState('');
  const [destino,   setDestino]   = useState('');
  const [data,      setData]      = useState('');
  const [categoria, setCategoria] = useState('');

  const formatarData = (texto) => {
    // Auto-formata para DD/MM/AAAA
    const nums = texto.replace(/\D/g, '');
    if (nums.length <= 2) return nums;
    if (nums.length <= 4) return `${nums.slice(0,2)}/${nums.slice(2)}`;
    return `${nums.slice(0,2)}/${nums.slice(2,4)}/${nums.slice(4,8)}`;
  };

  const converterData = (dataBR) => {
    if (!dataBR || dataBR.length < 8) return '';
    const [d, m, a] = dataBR.split('/');
    return a && m && d ? `${a}-${m}-${d}` : '';
  };

  const handleBuscar = () => {
    if (!origem.trim() || !destino.trim()) {
      return Alert.alert('Atenção', 'Informe a cidade de origem e destino');
    }
    navigation.navigate('SearchResults', {
      origem:    origem.trim(),
      destino:   destino.trim(),
      data:      converterData(data),
      categoria,
    });
  };

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      {/* Header */}
      <View style={styles.header}>
        <View>
          <Text style={styles.greeting}>Olá, {user?.nome?.split(' ')[0]} 👋</Text>
          <Text style={styles.headerSub}>Para onde vamos hoje?</Text>
        </View>
        <Text style={styles.logoSmall}>YBR</Text>
      </View>

      {/* Card de busca */}
      <View style={styles.searchCard}>
        <Text style={styles.searchTitle}>Buscar Veículo</Text>

        <Text style={styles.label}>📍 Origem</Text>
        <TextInput
          style={styles.input}
          placeholder="Ex: Chapecó"
          value={origem}
          onChangeText={setOrigem}
          placeholderTextColor="#aaa"
        />

        {/* Swap visual */}
        <TouchableOpacity
          style={styles.swapBtn}
          onPress={() => { const tmp = origem; setOrigem(destino); setDestino(tmp); }}
        >
          <Text style={styles.swapIcon}>⇅</Text>
        </TouchableOpacity>

        <Text style={styles.label}>🏁 Destino</Text>
        <TextInput
          style={styles.input}
          placeholder="Ex: Xanxerê"
          value={destino}
          onChangeText={setDestino}
          placeholderTextColor="#aaa"
        />

        <Text style={styles.label}>📅 Data de início (DD/MM/AAAA)</Text>
        <TextInput
          style={styles.input}
          placeholder="Ex: 15/06/2025"
          value={data}
          onChangeText={(t) => setData(formatarData(t))}
          keyboardType="numeric"
          maxLength={10}
          placeholderTextColor="#aaa"
        />

        {/* Categoria */}
        <Text style={styles.label}>Tipo de veículo</Text>
        <View style={styles.categoriaRow}>
          {CATEGORIAS.map(cat => (
            <TouchableOpacity
              key={cat.value}
              style={[styles.catBtn, categoria === cat.value && styles.catBtnActive]}
              onPress={() => setCategoria(cat.value)}
            >
              <Text style={styles.catIcon}>{cat.icon}</Text>
              <Text style={[styles.catLabel, categoria === cat.value && styles.catLabelActive]}>{cat.label}</Text>
            </TouchableOpacity>
          ))}
        </View>

        <TouchableOpacity style={styles.btnBuscar} onPress={handleBuscar}>
          <Text style={styles.btnBuscarText}>🔍  Buscar Veículos</Text>
        </TouchableOpacity>
      </View>

      {/* Cidades sugeridas */}
      <Text style={styles.sectionTitle}>Cidades populares</Text>
      <View style={styles.cidadesGrid}>
        {CIDADES_SUGERIDAS.map(cidade => (
          <TouchableOpacity
            key={cidade}
            style={styles.cidadeChip}
            onPress={() => setOrigem(cidade)}
          >
            <Text style={styles.cidadeText}>📍 {cidade}</Text>
          </TouchableOpacity>
        ))}
      </View>

      {/* Banner P2P */}
      <View style={styles.banner}>
        <Text style={styles.bannerIcon}>🔗</Text>
        <View style={{ flex: 1 }}>
          <Text style={styles.bannerTitle}>Como funciona o matching?</Text>
          <Text style={styles.bannerText}>
            Ao reservar um veículo para ir de A → B, conectamos você com alguém que precisa fazer B → A.
            Resultado: <Text style={{ fontWeight: 'bold' }}>até 35% de desconto</Text> para ambos!
          </Text>
        </View>
      </View>

      <View style={{ height: 30 }} />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container:     { flex: 1, backgroundColor: '#f9f9f9' },
  header:        { backgroundColor: '#F5C518', paddingHorizontal: 24, paddingTop: 56, paddingBottom: 28, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  greeting:      { fontSize: 22, fontWeight: 'bold', color: '#1a1a1a' },
  headerSub:     { fontSize: 14, color: '#444', marginTop: 2 },
  logoSmall:     { fontSize: 22, fontWeight: '900', color: '#1a1a1a' },
  searchCard:    { backgroundColor: '#fff', margin: 16, borderRadius: 20, padding: 20, shadowColor: '#000', shadowOpacity: 0.08, shadowRadius: 10, elevation: 4 },
  searchTitle:   { fontSize: 18, fontWeight: 'bold', color: '#1a1a1a', marginBottom: 16 },
  label:         { fontSize: 13, fontWeight: '600', color: '#555', marginBottom: 6, marginTop: 10 },
  input:         { backgroundColor: '#f5f5f5', borderRadius: 10, paddingHorizontal: 14, paddingVertical: 12, fontSize: 15, color: '#1a1a1a' },
  swapBtn:       { alignSelf: 'flex-end', marginVertical: 4 },
  swapIcon:      { fontSize: 22, color: '#F5C518' },
  categoriaRow:  { flexDirection: 'row', gap: 8, marginTop: 4 },
  catBtn:        { flex: 1, alignItems: 'center', paddingVertical: 10, borderRadius: 10, backgroundColor: '#f5f5f5' },
  catBtnActive:  { backgroundColor: '#F5C518' },
  catIcon:       { fontSize: 20, marginBottom: 2 },
  catLabel:      { fontSize: 11, color: '#666', fontWeight: '600' },
  catLabelActive:{ color: '#1a1a1a' },
  btnBuscar:     { backgroundColor: '#F5C518', borderRadius: 12, paddingVertical: 14, alignItems: 'center', marginTop: 20 },
  btnBuscarText: { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a' },
  sectionTitle:  { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a', marginHorizontal: 16, marginTop: 8, marginBottom: 10 },
  cidadesGrid:   { flexDirection: 'row', flexWrap: 'wrap', paddingHorizontal: 12, gap: 8 },
  cidadeChip:    { backgroundColor: '#fff', borderRadius: 20, paddingHorizontal: 14, paddingVertical: 8, shadowColor: '#000', shadowOpacity: 0.05, shadowRadius: 4, elevation: 2 },
  cidadeText:    { fontSize: 13, color: '#333' },
  banner:        { backgroundColor: '#1a1a1a', margin: 16, borderRadius: 16, padding: 18, flexDirection: 'row', gap: 14, alignItems: 'flex-start' },
  bannerIcon:    { fontSize: 32 },
  bannerTitle:   { fontSize: 14, fontWeight: 'bold', color: '#F5C518', marginBottom: 4 },
  bannerText:    { fontSize: 13, color: '#ccc', lineHeight: 20 },
});
